export default __webpack_public_path__ + "static/media/031-life saver.58447091.svg";